import React from 'react';
import UnderHeader from '../../../shared/header/under-header';

import PrivacyContent from './components/privacy-content';
import Head from '../../../shared/head';

const PrivacyPolicy = () => {
    const heroImageContent = (
    <div id="hero-footer" className="hero-footer">
        <div className="row">
        <h1 className="brandon-light">Privacy Policy</h1>                        
        </div>
    </div>); 
    return(
        <>
            <Head title={`Loanpal ${window.location.pathname.split('/')[1]}`} />
            <UnderHeader                
                image="img-container-hero-footer-pages"                                
                bgColor="purple-header"
                border=""
                heroImageContent={heroImageContent}
                showDIYSlideshow={false}
                showSlideshowMovie={false}
            />   
            <PrivacyContent />                                
        </>                
    )
}

export default PrivacyPolicy;